module.exports = __webpack_public_path__ + "static/dying-every-day-73301adec1a9ab6f532834731431b57e.jpg";